/**
 * API origin, overridable per build with REACT_APP_API_ORIGIN.
 *
 * Defaults to the development/staging host, as requested. The file previously
 * hardcoded this same host with the production URLs commented out underneath,
 * so switching environments meant hand-editing source and remembering to swap
 * the comments back. It is an env var now, so neither environment requires a
 * code change:
 *
 *   npm run build                                                  -> staging
 *   REACT_APP_API_ORIGIN=https://api.onlineskolemad.dk npm run build -> production
 *
 * This matters more than usual here: the prerenderer bakes whatever this
 * resolves to into the generated HTML. Pointing it at an unreachable host
 * still produces pages that *look* fine — the static chrome renders — while
 * every API-backed section comes out empty.
 */
const API_ORIGIN = (
  process.env.REACT_APP_API_ORIGIN || "https://api.onlineskolemad.dk"
).replace(/\/+$/, "");

export const base_url = `${API_ORIGIN}/web/api/v1/`;
// No trailing slash: every call site composes this with a path that already
// starts with "/" (CAT_IMAGE_PATH, MENU_IMAGE_PATH, SEO_IMAGE_PATH). With the
// old trailing slash those produced "…onlineskolemad.dk//uploads/…", and the
// doubled slash was ending up in og:image and in JSON-LD image URLs.
export const image_url = API_ORIGIN;
export const public_url = `${API_ORIGIN}/api/`;
export const admin_url = `${API_ORIGIN}/admin/api/v1/`;

export const CAT_IMAGE_PATH = "/uploads/category-img/";
export const MENU_IMAGE_PATH = "/uploads/menu-img/";
export const PROFILE_IMAGE_PATH = "public/uploads/profile-img/";
// Matches the upload destination used by the admin seo-pages endpoints and the
// SEO_IMAGE_PATH default in food-services/ssr/renderSeoPage.js.
export const SEO_IMAGE_PATH = "/uploads/seo-banner-img/";

// NOTE: `site_url` used to be `window.location.origin`. That is unsafe during
// prerendering — it baked the prerender host (http://localhost:PORT) into the
// generated HTML's image URLs. Every usage was of the form
// `${site_url}/assets/...`, so those call sites now use root-relative
// "/assets/..." paths instead, which resolve correctly in dev, in production
// and while prerendering. For a canonical absolute origin, import SITE_URL
// from src/Seo/siteConfig.js.